module.exports = __webpack_public_path__ + "img/mach.837c88b.png";